<template>
  <div>
    <div v-for="(content, index) in visibleContents" :key="'content'+index">
      <ContentImage
        v-bind:key="index"
        v-if="content.imgPath"
        :imgSrc="content.imgPath"
        @imageInit="nextContent"
      />

      <ContentGiphy v-else-if="content.giphy" :giphy="content.giphy" @giphyInit="nextContent"/>

      <Typewriter
        v-else-if="content.copy"
        class="paragraph"
        :class="[
          { ['paragraph--' + content.color] : content.color },
          'paragraph--' + content.size
        ]"
        :text="content.copy"
        :speed="15"
        :pre-type-delay="500"
        @typed-line="onLineTyped"
        @complete="nextContent"
      ></Typewriter>
    </div>
  </div>
</template>


<script>
import Typewriter from "./Typewriter";
import ContentGiphy from "./ContentGiphy";
import ContentImage from "./ContentImage";

export default {
  name: "Content",
  components: {
    Typewriter,
    ContentGiphy,
    ContentImage
  },
  props: ["contents"],
  data() {
    return {
      giphy: [],
      visibleContents: [],
      contentCounter: 0
    };
  },
  computed: {
    imageInit() {
      // this.$store.commit("SCROLLTRIGGER");
      this.$store.commit("CHECKHEIGHT");
      this.nextContent();
      return null;
    }
  },
  mounted() {
    this.visibleContents.push(this.contents[0]);
  },
  methods: {
    nextContent() {
      this.contentCounter += 1;
      if (this.contentCounter < this.contents.length) {
        this.visibleContents.push(this.contents[this.contentCounter]);

        // this.$store.commit("SCROLLTRIGGER");
        this.$store.commit("CHECKHEIGHT");
      } else {
        this.$emit("complete");
      }
    },
    onLineTyped() {
      // this.$store.commit('SCROLLTRIGGER');
      this.$store.commit("CHECKHEIGHT");
    }
  }
};
</script>


<style lang="scss">
img {
  max-width: 100%;
  display: inline-block !important;
}

.content__giphy,
.content__image {
  height: 150px;
  display: flex;
  justify-content: flex-end;

  img {
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Content.vue